import { useState, useRef } from 'react';

const useSkillState = () => {
    const [cardSkills, setCardSkills] = useState([]);
    const [activeSkills, setActiveSkills] = useState([]);
    const [uniqueSkill, setUniqueSkill] = useState(null);
    const [uniqueSkillLevel, setUniqueSkillLevel] = useState(1);
    const [supportDeck, setSupportDeck] = useState(Array(6).fill({ support: null, capLevel: 0 }));

    // Refs for persistence state that shouldn't trigger re-renders
    const skillsRestored = useRef(false);

    return {
        cardSkills, setCardSkills,
        activeSkills, setActiveSkills,
        uniqueSkill, setUniqueSkill,
        uniqueSkillLevel, setUniqueSkillLevel,
        supportDeck, setSupportDeck,
        skillsRestored
    };
};

export default useSkillState;
// Revisado: 2025-12-16
